/**
 * Per-post attribution: clicks, intents and sales driven by the post.
 */
import { useEffect, useState } from "react";
import { api, fmt } from "@/lib/api";

export function AttributionPanel({ postId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    api
      .get(`/posts/${postId}/attribution`)
      .then((res) => {
        if (active) setData(res.data);
      })
      .catch(() => {
        if (active) setData(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [postId]);

  if (loading) return null;
  if (!data) return null;
  const c = data.confirmed || {};
  const i = data.intents || {};
  const hasAny = c.ventas > 0 || c.ingresos > 0 || i.whatsapp > 0 || i.bank > 0;
  if (!hasAny) {
    return (
      <div className="mt-3 px-3 py-2 bg-zinc-50 border border-zinc-200 text-[11px] text-muted2">
        💸 Aún sin ventas ni leads atribuidos a esta publicación. En cuanto alguien
        compre o haga clic en WhatsApp/Transferencia desde tu link <code>?p={postId.slice(0, 8)}</code>, lo verás aquí.
      </div>
    );
  }
  return (
    <div
      className="mt-3 px-3 py-2 bg-[#E8F5E9] border border-[#A5D6A7]"
      data-testid={`attribution-${postId}`}
    >
      <div className="text-[10px] uppercase tracking-[0.15em] text-[#1B5E20] font-semibold mb-1">
        💸 Ventas atribuidas
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs">
        <span><strong className="tabular-nums">{c.ventas || 0}</strong> ventas</span>
        <span><strong className="tabular-nums">{c.unidades || 0}</strong> uds.</span>
        <span>
          Ingresos: <strong className="tabular-nums text-[#1B5E20]">{fmt(c.ingresos || 0)}</strong>
        </span>
        <span>
          Utilidad: <strong className="tabular-nums">{fmt(c.utilidad || 0)}</strong>
        </span>
        {(i.whatsapp > 0 || i.bank > 0) && (
          <span className="text-muted2">
            leads: WA {i.whatsapp || 0} · banco {i.bank || 0}
          </span>
        )}
      </div>
    </div>
  );
}

// Channels panel — per-post manual distribution plan. Renders one row per
// channel target with status + buttons "Copiar mensaje y abrir canal" +
// "Marcar publicado".  Channel metadata (nombre, plataforma, link) is loaded
// once from the directory and looked up by id at render time.
